import React from "react";
import NavBar from "../components/NavBar";
import Calendar from "../components/Calendar";
import MainCard from "../components/MainCard";
import Menu from "../components/Menu";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./Home.css";

function getInitialLang() {
  const url = new URL(window.location.href);
  return url.searchParams.get("lang") || "en";
}

function Home() {
  const [lang, setLang] = React.useState(getInitialLang());

  React.useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lang);
    window.history.replaceState({}, "", url.toString());
  }, [lang]);

  return (
    <>
      <NavBar lang={lang} setLang={setLang} />
      <div style={{ maxWidth: "1550px", margin: "0 auto" }}>
        <MainCard lang={lang} setLang={setLang} />
        <div style={{ marginTop: "70px", marginBottom: "50px" }}>
          <h2 className="calendar-title">
            {lang === "es" ? "Dónde Encontrarnos" : "Where To Find Us"}
          </h2>
          <p className="calendar-description">
            {lang === "es"
              ? "Utiliza el calendario a continuación para ver nuestros próximos eventos y ubicaciones."
              : "Use the calendar below to see our upcoming events and locations."}
          </p>
        </div>
        <Calendar lang={lang} />
        {/* <div style={{ marginTop: "70px", marginBottom: "50px" }}>
          <h2
            style={{
              textAlign: "center",
              margin: 0,
              marginBottom: "20px",
              fontSize: "60px",
              fontWeight: "bold",
            }}
          >
            {lang === "es" ? "Nuestro Menú" : "Our Menu"}
          </h2>
          <p
            style={{
              textAlign: "center",
              fontSize: "26px",
              margin: 0,
            }}
          >
            {lang === "es"
              ? "¡Prueba nuestras deliciosas empanadas y más!"
              : "Try our delicious empanadas and more!"}
          </p>
        </div>
        <Menu lang={lang} /> */}
      </div>
      <footer
        style={{
          padding: "30px 0",
          textAlign: "center",
          marginTop: "40px",
          marginBottom: "40px",
        }}
      >
        <div
          style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "16px" }}
        >
          {lang === "es" ? "Hecho con" : "Made with"}
          <span style={{ margin: "0 4px" }}>❤️</span>
          {lang === "es" ? "en" : "in"}
          <br />
          Charleston, SC<span style={{ margin: "0 4px" }}>🌴</span>
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: "18px" }}>
          <a
            href="https://www.instagram.com/chsempanadas/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block", margin: 0, padding: 0 }}
          >
            <Icon
              icon="mdi:instagram"
              style={{
                fontSize: "32px",
                color: "#ea2146ff",
                verticalAlign: "middle",
              }}
            />
          </a>
          {/* <a
            href="https://www.facebook.com/profile.php?id=61579323742636"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block", margin: 0, padding: 0 }}
          >
            <Icon
              icon="mdi:facebook"
              style={{
                fontSize: "32px",
                color: "#1877F3",
                verticalAlign: "middle",
              }}
            />
          </a> */}
        </div>
      </footer>
    </>
  );
}

export default Home;
